/*
 Scroll an element to the center of a container viewport element (position relative to the container */ 

    // yOffset is addition amount to add to the position of the element (eg if want in relation to diff element)
(function($) {
    //todo: could incorporate overlap
    $.fn.centeredScroll = function($scroller, yOffset, xOffset, cb) { 
        var $el = this,
            
            elOffset = $el.position(),
            
                yToScroll = elOffset.top + (yOffset ? yOffset : 0),
                xToScroll = elOffset.left + (xOffset ? xOffset : 0),
            
                elHeight = $el.height(),
                elWidth = $el.width(),
           
            viewPortHeight = $scroller.height(),
            viewPortWidth =  $scroller.width();
           
        yToScroll = elHeight < viewPortHeight
            ? yToScroll - (viewPortHeight / 2) - (elHeight / 2)
            : yToScroll;

        xToScroll = (elWidth < viewPortWidth)
            ? xToScroll - (viewPortWidth / 2) - (elWidth / 2)
            : xToScroll;

    
        $scroller.stop().animate({
            scrollTop: yToScroll,
            scrollLeft: xToScroll
        }, {
            duration: 0,
            complete: setTimeout(function() { /* allow scroll to complete first */
                cb && typeof cb === "function" && cb();
            },0)
        });

    };


}(jQuery));


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/centeredScroll.js
 ** module id = 554
 ** module chunks = 0
 **/